export default {
  ID: 5,
  firstName: "یاسین",
  lastName: "سعیدی",
  email: "yasin.saedi.test@gmail.com",
  mobile: "09129871234",
  type: "real",
  category_id: "22",
  category: "ایزارالات",
  categoryID: 22,
  state: "تهران",
  city: "تهران",
  town: "تهران",
  postal_code: 1349675637,
  national_code: "104023492",
  identity_number: "52330505",
  phone: "02112345678",
  address:"تهران خ رودکی",
};
